/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverRankSettingsAdminDto } from '../models/DriverRankSettingsAdminDto';
import type { PatchDriverRankSettingsActivationAdminRequest } from '../models/PatchDriverRankSettingsActivationAdminRequest';
import type { PostDriverRankSettingsAdminRequest } from '../models/PostDriverRankSettingsAdminRequest';
import type { PutDriverRankSettingsAdminRequest } from '../models/PutDriverRankSettingsAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverRankSettingsService {
    /**
     * **Required Policy:** `ViewDriverRankSettings`
     * @returns DriverRankSettingsAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankSettingsAdmin(): CancelablePromise<Array<DriverRankSettingsAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverranksettings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverRankSettings`
     * @returns DriverRankSettingsAdminDto OK
     * @throws ApiError
     */
    public static postDriverRankSettingsAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverRankSettingsAdminRequest,
    }): CancelablePromise<DriverRankSettingsAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverranksettings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverRankSettings`
     * @returns DriverRankSettingsAdminDto OK
     * @throws ApiError
     */
    public static getDriverRankSettingsByIdAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverRankSettingsAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverranksettings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverRankSettings`
     * @returns DriverRankSettingsAdminDto OK
     * @throws ApiError
     */
    public static putDriverRankSettingsAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutDriverRankSettingsAdminRequest,
    }): CancelablePromise<DriverRankSettingsAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driverranksettings/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverRankSettings`
     * @returns DriverRankSettingsAdminDto OK
     * @throws ApiError
     */
    public static postDriverRankSettingsActivationAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchDriverRankSettingsActivationAdminRequest,
    }): CancelablePromise<DriverRankSettingsAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverranksettings/{id}/activation',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
